"use strict";

exports.__esModule = true;
exports.RealtimeBatchSubscription = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _createSubscription = require("../../../Utils/createSubscription");
var _RealtimeConnectionContext = require("./RealtimeConnectionContext");
var _excluded = ["realtime", "channels", "children", "onData"];
var _dec, _class, _RealtimeBatchSubscription;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var InnerSubscription = (0, _createSubscription.createSubscription)({
  // Re-read on every notification (see createSubscription): every declared
  // channel is present, and its value stays `undefined` until it delivers.
  // Consumers must treat `undefined` as "no value yet", never as a number.
  getCurrentValue: function getCurrentValue(_ref) {
    var cache = _ref.cache,
      channels = _ref.channels;
    var current = {};
    for (var _i = 0, _Object$keys = Object.keys(channels); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      current[key] = cache === undefined ? undefined : cache.getCachedValue(channels[key]);
    }
    return current;
  },
  subscribe: function subscribe(_ref2, callback) {
    var cache = _ref2.cache,
      channels = _ref2.channels,
      onData = _ref2.onData;
    if (cache === undefined) {
      return function () {};
    }
    var subscriptions = {};
    var current = {};
    var _loop = function _loop() {
      var key = _Object$keys2[_i2];
      var params = channels[key];
      subscriptions[key] = cache.subscribe(params, {
        next: function next(value) {
          var _Object$assign;
          current = Object.assign({}, current, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
          if (typeof onData === "function") {
            onData(current);
          }
          callback();
        },
        complete: function complete() {
          return undefined;
        },
        error: callback
      });
    };
    for (var _i2 = 0, _Object$keys2 = Object.keys(channels); _i2 < _Object$keys2.length; _i2++) {
      _loop();
    }
    return function () {
      if (subscriptions !== undefined) {
        for (var _i3 = 0, _Object$keys3 = Object.keys(subscriptions); _i3 < _Object$keys3.length; _i3++) {
          var key = _Object$keys3[_i3];
          subscriptions[key].unsubscribe();
        }
        subscriptions = undefined;
      }
    };
  }
});

/**
 * A subscription to a dictionary of channels on a realtime connection.
 */
var RealtimeBatchSubscription = exports.RealtimeBatchSubscription = (_dec = _RealtimeConnectionContext.RealtimeConnectionContext.withContext, _dec(_class = (_RealtimeBatchSubscription = /*#__PURE__*/function (_Component) {
  function RealtimeBatchSubscription() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(RealtimeBatchSubscription, _Component);
  RealtimeBatchSubscription.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.realtime.connection === prevState.connection && props.onData === prevState.onData && (0, _reactFastCompare["default"])(props.channels, prevState.channels)) {
      return null;
    }
    return makeState(props);
  };
  var _proto = RealtimeBatchSubscription.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      realtime = _this$props.realtime,
      channels = _this$props.channels,
      children = _this$props.children,
      onData = _this$props.onData,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(InnerSubscription, _extends({
      source: this.state
    }, extra), children);
  };
  return RealtimeBatchSubscription;
}(_react.Component), _RealtimeBatchSubscription.defaultProps = {
  realtime: undefined
}, _RealtimeBatchSubscription)) || _class);
function makeState(_ref3) {
  var realtime = _ref3.realtime,
    channels = _ref3.channels,
    onData = _ref3.onData;
  var connection = realtime.connection,
    cache = realtime.cache;
  return {
    connection: connection,
    cache: cache,
    channels: channels,
    onData: onData
  };
}